/** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material'
import { fullWidthAccordionContainer } from './FullWidthAccordion.styles'
import { Accordion, AccordionProps } from '../Accordion'

export const FullWidthAccordion = ({ ...props }: AccordionProps) => {
  const theme = useTheme()
  return <Accordion customStyle={fullWidthAccordionContainer({ theme })} {...props}></Accordion>
}
